import { useState } from "react";
import { QrReader } from "react-qr-reader";
import { Note, Page } from "../../../../../helbest";
import HeaderBack from "../../../../../helbest/HeaderBack/HeaderBack";
import { useTranslation } from "react-i18next";
import FlashlightButton from "./FlashlightButton";
import { useLangNavigate } from "../../../../../hooks/useLangNavigate";
import styles from "./QRCodeReaderPage.module.css";
import { API } from "../../../../../request/api";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import {
  set_services_phone_number,
  set_services_order_lines,
  set_is_coupon,
  set_services_skip_step,
  set_services_qr_order_lines,
  set_services_qr_meta,
} from "../../../../../store/actions/services_actions";

const QRCodeReaderPage = () => {
  const [startScan, setStartScan] = useState(true);
  const [data, setData] = useState("");
  const [qrTrack, setQrTrack] = useState(null);
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const { lng, ltd } = location.state || {};

  const handleResult = (result) => {
    if (result?.text && ltd !== null && lng !== null && startScan) {
      setData(result.text);
      setStartScan(false);
      scan_qr_code(result.text);
    }
  };

  const scan_qr_code = (token) => {
    API.post.qrLocation({ token: token, lat: ltd, long: lng }).then((response) => {
      if (response?.success || response?.code === 200) {
        const { phone_number, skip_step, order_lines, bill_id } = response.data;

        dispatch(set_services_phone_number(phone_number));
        dispatch(
          set_services_order_lines(
            (order_lines || []).map((o) => o.order_line_id)
          )
        );
        dispatch(set_services_qr_order_lines(order_lines || []));
        dispatch(set_services_skip_step(skip_step));
        dispatch(set_services_qr_meta({
          qr_token: token,
          qr_lat: ltd,
          qr_lng: lng,
        }));
        dispatch(set_services_qr_meta({ qr_bill_id: bill_id }));
        dispatch(set_is_coupon(true));

        navigate(skip_step === true ? "/select-service/" : "/new-service/");
      } else {
        Note.error(response.message);
        setStartScan(true);
      }
    });
  };

  return (
    <Page
      className="bg-gray-light"
      showFooter={true}
      headerFix
      logo
      back
      customHeader={
        <HeaderBack title={t("drawer.new_service")} url="/new-service" />
      }
    >
      <div style={{ textAlign: "center", padding: "20px" }}>
        <div className={styles.qrReaderContainer}>
          <div className={styles.qrTitle}>{t("new_service.qr_code.guide")}</div>{" "}
          {startScan ? (
            <div className={styles.qrReaderWrapper}>
              <QrReader
                constraints={{ facingMode: "environment" }}
                onResult={handleResult}
                onVideoTrack={(track) => setQrTrack(track)}
                style={{ width: "100%" }}
              />
              <div className={styles.qrFrame}>
                <div className={`${styles.corner} ${styles.topLeft}`} />
                <div className={`${styles.corner} ${styles.topRight}`} />
                <div className={`${styles.corner} ${styles.bottomLeft}`} />
                <div className={`${styles.corner} ${styles.bottomRight}`} />
              </div>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </Page>
  );
};

export default QRCodeReaderPage;